export class UserRole {
    public static SuperAdministrator = "Super Administrator";
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/user-role.constants.ts